import React from 'react';
import PropTypes from 'prop-types';

//MUI components
import Grid from '@mui/material/Grid';
import PersonPinTwoToneIcon from '@mui/icons-material/PersonPinTwoTone';
import {Typography} from '@mui/material';

// REDUX
import {connect} from 'react-redux';
import {searchPerformedOnSelector} from 'redux/slices/searchFormSlice';

const NotFoundError = ({searchPerformedOn}) => {
  return (
    <Grid container justifyContent="center" alignItems="center" direction="column">
      <PersonPinTwoToneIcon color="primary" style={{fontSize: 64, marginTop: 48}} />
      <Typography variant="h5" style={{marginTop: 18}}>
        {searchPerformedOn} not found
      </Typography>
    </Grid>
  );
};

NotFoundError.propTypes = {
  searchPerformedOn: PropTypes.string
};

const mapStateToProps = (state) => ({
  searchPerformedOn: searchPerformedOnSelector(state)
});

export default connect(mapStateToProps)(NotFoundError);
